import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import { PartRegion } from '@/features/storefront/parts/PartRegion';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';

/**
 * A boutique's product page: the picture stood up tall with its thumbnails in a
 * rail beside it, and a column that stays put while the picture scrolls.
 */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-14 py-10 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)]">
    <PartRegion name="gallery" />
    <PartRegion name="main" className="min-w-0 lg:sticky lg:top-28 lg:self-start" />
  </StorefrontContainer>
);
